(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/qr-scanner/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tur/qr-scanner/assets/javascripts/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let animationFrameId;
let showingValidMessage = false;
const GREEN = '#00D773';
const ONE_SECOND_MS = 1000;
const showErrorDialog = _ref => {
  let _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Fel' : _ref$title,
    message = _ref.message,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _.noop : _ref$onClick,
    _ref$customAction = _ref.customAction,
    customAction = _ref$customAction === void 0 ? null : _ref$customAction;
  const actions = [];
  if (customAction) {
    actions.push(customAction);
  }
  actions.push({
    title: 'Okej',
    callback: (e, forms, dialog) => {
      dialog.close();
      onClick();
    }
  });
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.NEUTRAL,
    type: svs.ui.dialog.type.INFO,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: message
    }],
    actions
  }));
};
const drawCornersSquare = _ref2 => {
  let topLeftCorner = _ref2.topLeftCorner,
    bottomRightCorner = _ref2.bottomRightCorner,
    topRightCorner = _ref2.topRightCorner,
    bottomLeftCorner = _ref2.bottomLeftCorner,
    ctx = _ref2.ctx;
  ctx.lineWidth = 2;
  ctx.strokeStyle = GREEN;
  ctx.beginPath();
  ctx.moveTo(topLeftCorner.x, topLeftCorner.y);
  ctx.lineTo(topRightCorner.x, topRightCorner.y);
  ctx.lineTo(bottomRightCorner.x, bottomRightCorner.y);
  ctx.lineTo(bottomLeftCorner.x, bottomLeftCorner.y);
  ctx.lineTo(topLeftCorner.x, topLeftCorner.y);
  ctx.stroke();
};
const calculateRotationAngle = _ref3 => {
  let topLeftCorner = _ref3.topLeftCorner,
    topRightCorner = _ref3.topRightCorner;
  const dx = topRightCorner.x - topLeftCorner.x;
  const dy = topRightCorner.y - topLeftCorner.y;
  return Math.atan2(dy, dx);
};
const drawCornersCode = data => {
  const topLeftCorner = data.topLeftCorner,
    bottomRightCorner = data.bottomRightCorner,
    topRightCorner = data.topRightCorner,
    bottomLeftCorner = data.bottomLeftCorner,
    ctx = data.ctx,
    _data$cornerLength = data.cornerLength,
    cornerLength = _data$cornerLength === void 0 ? 10 : _data$cornerLength;
  const angle = calculateRotationAngle({
    topLeftCorner,
    topRightCorner
  });
  if (Math.abs(angle) > 0.3) {
    return drawCornersSquare(data);
  }
  ctx.lineWidth = 2;
  ctx.strokeStyle = GREEN;

  ctx.beginPath();
  ctx.moveTo(topLeftCorner.x, topLeftCorner.y);
  ctx.lineTo(topLeftCorner.x + cornerLength, topLeftCorner.y);
  ctx.moveTo(topLeftCorner.x, topLeftCorner.y);
  ctx.lineTo(topLeftCorner.x, topLeftCorner.y + cornerLength);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.moveTo(bottomLeftCorner.x, bottomLeftCorner.y);
  ctx.lineTo(bottomLeftCorner.x + cornerLength, bottomLeftCorner.y);
  ctx.moveTo(bottomLeftCorner.x, bottomLeftCorner.y);
  ctx.lineTo(bottomLeftCorner.x, bottomLeftCorner.y - cornerLength);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.moveTo(topRightCorner.x, topRightCorner.y);
  ctx.lineTo(topRightCorner.x - cornerLength, topRightCorner.y);
  ctx.moveTo(topRightCorner.x, topRightCorner.y);
  ctx.lineTo(topRightCorner.x, topRightCorner.y + cornerLength);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.moveTo(bottomRightCorner.x, bottomRightCorner.y);
  ctx.lineTo(bottomRightCorner.x - cornerLength, bottomRightCorner.y);
  ctx.moveTo(bottomRightCorner.x, bottomRightCorner.y);
  ctx.lineTo(bottomRightCorner.x, bottomRightCorner.y - cornerLength);
  ctx.stroke();
  ctx.closePath();
};
const startAnimation = (targetFPS, updateCallback) => {
  const fpsInterval = 1000 / targetFPS; 
  let lastTime = performance.now(); 
  const animate = currentTime => {
    const elapsed = currentTime - lastTime;
    if (elapsed >= fpsInterval) {
      lastTime = currentTime - elapsed % fpsInterval; 
      updateCallback(); 
    }
    requestAnimationFrame(animate); 
  };
  animationFrameId = requestAnimationFrame(animate); 
};
const debouncedHideInvalidMsg = _.debounce(_ref4 => {
  let url = _ref4.url,
    error = _ref4.error,
    setMessage = _ref4.setMessage;
  !showingValidMessage && setMessage(null);
  svs.tur.qrScanner.qrLogger.warn("Invalid QR-code detected (".concat(url, ") - ").concat(error === null || error === void 0 ? void 0 : error.message));
}, ONE_SECOND_MS * 2);
const debouncedInvalidMsg = _.debounce(_ref5 => {
  let resumeScan = _ref5.resumeScan,
    error = _ref5.error,
    url = _ref5.url,
    setMessage = _ref5.setMessage;
  resumeScan();
  !showingValidMessage && setMessage({
    error: true,
    message: true
  });
  debouncedHideInvalidMsg({
    url,
    error,
    setMessage
  });
}, ONE_SECOND_MS / 2);
const debouncedHideValidMsg = _.debounce(_ref6 => {
  let resumeScan = _ref6.resumeScan,
    setMessage = _ref6.setMessage;
  resumeScan();
  setMessage(null);
  showingValidMessage = false;
}, ONE_SECOND_MS * 4);
const handleQrCode = _ref7 => {
  let url = _ref7.url,
    resumeScan = _ref7.resumeScan,
    setMessage = _ref7.setMessage,
    validateQrCode = _ref7.validateQrCode;
  try {
    validateQrCode(url);
    svs.tur.qrScanner.qrLogger.info("Valid QR-code detected (".concat(url, ")"));
    showingValidMessage = true;
    setMessage({
      error: false,
      url,
      message: true
    });
    debouncedHideValidMsg({
      resumeScan,
      setMessage
    });
  } catch (e) {
    debouncedInvalidMsg({
      resumeScan,
      error: e,
      url,
      setMessage
    });
  }
};
const scanQRCodeWithJsQR = videoParentRef => {
  let stream;
  let started = false;
  let pauseScan = false;
  const resumeScan = () => {
    pauseScan = false;
  };
  const isAndroid = /Android/i.test(navigator.userAgent);
  const getPreferredCameraDevice = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === 'videoinput');
    if (isAndroid) {
      const preferred = videoDevices.find(device => device.label.toLowerCase().includes('camera2 0'));
      if (preferred) return preferred;
    }
    return null;
  };
  const start = async _ref8 => {
    let validateQrCode = _ref8.validateQrCode,
      setMessage = _ref8.setMessage;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      return;
    }
    if (started) {
      return;
    } 
    started = true;
    const device = await getPreferredCameraDevice();

    const videoConstraints = {
      width: {
        ideal: 640
      },
      height: {
        ideal: 360
      },
      frameRate: {
        ideal: 15,
        max: 30
      }
    };
    if (device) {
      videoConstraints.deviceId = {
        exact: device.deviceId
      };
    } else {
      videoConstraints.facingMode = {
        ideal: 'environment'
      };
    }
    stream = await navigator.mediaDevices.getUserMedia({
      video: videoConstraints
    });

    const video = document.createElement('video');
    video.setAttribute('id', 'qr-scanner-video');
    video.setAttribute('playsinline', 'true'); 
    video.classList.add('qr-scanner-stream');
    video.classList.add('absolute');
    video.srcObject = stream;
    await video.play();

    videoParentRef.appendChild(video);

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', {
      willReadFrequently: true
    });
    canvas.classList.add('qr-scanner-rect-canvas');
    canvas.classList.add('qr-scanner-stream');
    videoParentRef.prepend(canvas);
    const scanFrame = () => {
      context.clearRect(0, 0, context.canvas.width, context.canvas.height);
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);
        if (code) {
          drawCornersCode(_objectSpread(_objectSpread({}, code.location), {}, {
            ctx: context
          }));
          if (!pauseScan) {
            pauseScan = true;
            handleQrCode({
              url: code.data,
              resumeScan,
              validateQrCode,
              setMessage
            });
          }
        }
      }
    };
    startAnimation(60, scanFrame);
  };
  const stop = () => {
    var _stream;
    started = false;
    animationFrameId && cancelAnimationFrame(animationFrameId);
    (_stream = stream) === null || _stream === void 0 || _stream.getTracks().forEach(track => track.stop());
  };
  return {
    start,
    stop
  };
};
const hideFooter = () => {
  var _document$querySelect;
  return (_document$querySelect = document.querySelector('.page-footer')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.classList) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.add('qr-scanner-hide-page-footer');
};
const showFooter = () => {
  var _document$querySelect2;
  return (_document$querySelect2 = document.querySelector('.page-footer')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.classList) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.remove('qr-scanner-hide-page-footer');
};
const disableBodyScroll = () => {
  var _document$querySelect3;
  return (_document$querySelect3 = document.querySelector('html')) === null || _document$querySelect3 === void 0 || (_document$querySelect3 = _document$querySelect3.classList) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.add('disable-body-scroll');
};
const enableBodyScroll = () => {
  var _document$querySelect4;
  return (_document$querySelect4 = document.querySelector('html')) === null || _document$querySelect4 === void 0 || (_document$querySelect4 = _document$querySelect4.classList) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.remove('disable-body-scroll');
};
const addListenerForVisibilityChange = destroy => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      destroy();
    }
  });
};
const removeListenerForVisibilityChange = destroy => {
  document.removeEventListener('visibilitychange', destroy);
};
const hasValidDevice = () => {
  const allowedDevicesRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i; 
  return allowedDevicesRegex.test(navigator.userAgent);
};
setGlobal('svs.tur.qrScanner.utils', {
  scanQRCodeWithJsQR,
  hideFooter,
  showFooter,
  disableBodyScroll,
  enableBodyScroll,
  addListenerForVisibilityChange,
  removeListenerForVisibilityChange,
  showErrorDialog,
  hasValidDevice
});

 })(window);